import {
  useMostAccessedCatalogsSource,
  UseMostAccessedCatalogsSourceParams,
} from './most-accessed-catalogs-source';

export const useMostAccessedCatalogsByTitleSource = (
  params: UseMostAccessedCatalogsSourceParams,
  options?: { enabled?: boolean }
) => useMostAccessedCatalogsSource('title', params, options);
